import { datadogLogs } from "@datadog/browser-logs";

const DATADOG_CONFIGURED = [false];
export const setupDatadog = ({
  env = "prod",
  version,
  service,
  clientToken,
}: {
  env: "prod" | "staging" | "dev";
  clientToken: string;
  version?: string;
  service?: string;
}) => {
  if (DATADOG_CONFIGURED[0]) {
    console.warn("Datadog already configured");
    return;
  }
  DATADOG_CONFIGURED[0] = true;
  datadogLogs.init({
    clientToken: clientToken,
    site: "datadoghq.eu",
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: service,
    version: version,
    env,
  });
  datadogLogs.setGlobalContextProperty("env", env);
};

export default datadogLogs;
